import React, { useEffect }  from 'react';
import { setMetaTags } from '../Functions/SetHeaders';
import { useLocation, useParams } from 'react-router-dom';

export default function MetaTags19 (props){
  const {data: dataRaw, lan, dataMain} = props;
  const location = useLocation()
  const params = useParams()
  const data = JSON.parse(dataRaw);
  useEffect(() => {
    let title = data.title;
    if(title === '${auto}'){
      if(dataMain.Country && dataMain.Country.Country_Url === params.country){
        title = lan.filename === "fa" ? "تور " + dataMain.Country.Country_Name : dataMain.Country.Country_En_Name + " Tour"
      }
    }
    let desc = data["meta-desc"];
    if(desc === '${auto}'){
      if(dataMain.Country && dataMain.Country.Country_Url === params.country){
        desc = lan.filename === "fa" ? "تور " + dataMain.Country.Country_Name : dataMain.Country.Country_En_Name + " Tour"
      }
    }
    let cano = window.location.protocol + "//" + window.location.host + location.pathname
    setMetaTags(title, desc, "", cano);
  }, []);
  useEffect(() => {
    let title = data.title;
    if(title === '${auto}'){
      if(dataMain.Country && dataMain.Country.Country_Url === params.country){
        title = lan.filename === "fa" ? "تور " + dataMain.Country.Country_Name : dataMain.Country.Country_En_Name + " Tour"
      }
    }
    let desc = data["meta-desc"];
    if(desc === '${auto}'){
      if(dataMain.Country && dataMain.Country.Country_Url === params.country){
        desc = lan.filename === "fa" ? "تور " + dataMain.Country.Country_Name : dataMain.Country.Country_En_Name + " Tour"
      }
    }
    let cano = window.location.protocol + "//" + window.location.host + location.pathname
    setMetaTags(title, desc, "", cano);
  }, [data]);
  return ""
}

